// Global so the Google Maps API can call it via &callback=initMap
window.initMap = function() {
	var map_style =	[
	  {
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#f5f5f5"
	      }
	    ]
	  },
	  {
	    "elementType": "labels.icon",
	    "stylers": [
	      {
	        "visibility": "off"
	      }
	    ]
	  },
	  {
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#616161"
	      }
	    ]
	  },
	  {
	    "elementType": "labels.text.stroke",
	    "stylers": [
	      {
	        "color": "#f5f5f5"
	      }
	    ]
	  },
	  {
	    "featureType": "administrative.land_parcel",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#bdbdbd"
	      }
	    ]
	  },
	  {
	    "featureType": "poi",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#eeeeee"
	      }
	    ]
	  },
	  {
	    "featureType": "poi",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#757575"
	      }
	    ]
	  },
	  {
	    "featureType": "poi.park",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#e5e5e5"
	      }
	    ]
	  },
	  {
	    "featureType": "poi.park",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#9e9e9e"
	      }
	    ]
	  },
	  {
	    "featureType": "road",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#ffffff"
	      }
	    ]
	  },
	  {
	    "featureType": "road.arterial",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#757575"
	      }
	    ]
	  },
	  {
	    "featureType": "road.highway",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#dadada"
	      }
	    ]
	  },
	  {
	    "featureType": "road.highway",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#616161"
	      }
	    ]
	  },
	  {
	    "featureType": "road.local",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#9e9e9e"
	      }
	    ]
	  },
	  {
	    "featureType": "transit.line",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#e5e5e5"
	      }
	    ]
	  },
	  {
	    "featureType": "transit.station",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#eeeeee"
	      }
	    ]
	  },
	  {
	    "featureType": "water",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#c9c9c9"
	      }
	    ]
	  },
	  {
	    "featureType": "water",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#9e9e9e"
	      }
	    ]
	  }
	]
	if (jQuery('.section-map').length > 0 && !(typeof google_map_locations === 'undefined')) {
		var center = {
			lat: google_map_locations.reduce(function(xs, x) {
				return xs + parseFloat(x.lat);
			}, 0) / google_map_locations.length,
			lng: google_map_locations.reduce(function(xs, x) {
				return xs + parseFloat(x.lng);
			}, 0) / google_map_locations.length,
		}
		var map = new google.maps.Map(document.getElementById('map'), {
			zoom: 11,
			center,
			disableDefaultUI: true,
			styles:map_style,
		});
		google_map_locations.forEach(function(location) {
			if(location.title != undefined){
							console.log('still here');
				var infowindow = new google.maps.InfoWindow({
					content: "<div class='map-info-window'>" +
						"<h4>" + location.title + "</h4>" +
						"<p>" + location.address + "</p>" +
						"<a class='btn pink-btn' href='" + location.permalink + "'>View</a>" +
					 "</div>"
				});
			}
			var marker = new google.maps.Marker({
				map,
				title: location.address,
				position: {
					lat: parseFloat(location.lat),
					lng: parseFloat(location.lng),
				},
			});
			if(location.title !== undefined){
				marker.addListener('click', function() {
					infowindow.open(map, marker);
				});
			}
		});
		jQuery('.map-jump').click(function(e){
			map.setCenter({
				lat : jQuery(this).data('lat'),
				lng : jQuery(this).data('lng')
			});
			map.setZoom(15);
			e.preventDefault();
		});

	}
};
